import { memo } from 'react'

import { Switcher } from '../../../components/Switcher'
import { formatNumber } from '../../../utils/numbersFormatting'
import { useGenerateMentorContext } from '../../HOCs/WithGenerateMentor'

interface IPageTitleProps {
  mentorsCount: number
}

const PageTitle: React.FC<IPageTitleProps> = memo(({ mentorsCount }) => {
  const { openPopup } = useGenerateMentorContext()

  return (
    <div className="flex justify-between items-center py-2">
      <h1 className="text-2xl font-bold text-white">
        All Companions
        {mentorsCount > 0 && <span> ({formatNumber(mentorsCount)})</span>}
      </h1>
      <div className="flex items-center gap-4">
        <Switcher />
        <button onClick={openPopup} className="btn btn-primary">
          Generate Companion
        </button>
      </div>
    </div>
  )
})

export { PageTitle }
